import { render } from "./BnccDetail.vue?vue&type=template&id=7cfd0518&scoped=true"
import script from "./BnccDetail.vue?vue&type=script&lang=ts"
export * from "./BnccDetail.vue?vue&type=script&lang=ts"

import "./BnccDetail.vue?vue&type=style&index=0&id=7cfd0518&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7cfd0518"

export default script